<template>
   <LayoutDisp1 v-if="n_obj == 1" :layout="layout"></LayoutDisp1>
   <LayoutDisp2 v-if="n_obj == 2" :layout="layout"></LayoutDisp2>
   <LayoutDisp3 v-if="n_obj == 3" :layout="layout"></LayoutDisp3>
   <LayoutDisp4 v-if="n_obj == 4" :layout="layout"></LayoutDisp4>
   <LayoutDisp5 v-if="n_obj == 5" :layout="layout"></LayoutDisp5>
   <LayoutDisp6 v-if="n_obj == 6" :layout="layout"></LayoutDisp6>
   <div v-if="n_obj < 1 ||  n_obj > 6">
       <h3>{{message}}</h3>
   </div>
</template>

<script>
import LayoutDisp1 from './LayoutDisp1.vue' 
import LayoutDisp2 from './LayoutDisp2.vue' 
import LayoutDisp3 from './LayoutDisp3.vue' 
import LayoutDisp4 from './LayoutDisp4.vue' 
import LayoutDisp5 from './LayoutDisp5.vue' 
import LayoutDisp6 from './LayoutDisp6.vue' 

export default {
  name: 'MainLayout',
  components: {
      LayoutDisp1,LayoutDisp2,LayoutDisp3,LayoutDisp4,LayoutDisp5,LayoutDisp6
  },
  data() {
      return {
        n_obj : 0,
        interval : 0,
        message : ""
      }
  },
  mounted() {
    let widgets = this.layout.widgets ;

    let n_obj = widgets.length ;
    if (n_obj <= 0)
          this.message = "NO LAYOUT MAP OBJECT DEFINED"
    else if (n_obj > 6)
          this.message = `TOO MANY OBJECT DEFINED: ${n_obj}`
    this.n_obj = n_obj ;
  },
  props: {
    layout  : Object    // contain 1 page screen with title and widgets
  },
}
</script>


